import { jsx as _jsx } from "react/jsx-runtime";
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { ImageMagnify, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { ProductImageHeight, ProductImageWidth } from '../../../constants/ProductConstants';
import { getVideoPlayerType } from '../../../util/VideoUtil';
import { Video } from '../../video/Video';
export const ProductMediaItem = ({ sourceSet, video, alt, isActive = true, pinchZoomRef, preloadLargeImage, tapZoomEnabled, stop, onClick, }) => {
    var _a;
    const isMobile = useMediaQueryMatchesOnMobile();
    if (video && ((_a = video.productVideoDetail) === null || _a === void 0 ? void 0 : _a.url)) {
        return (_jsx(Video, { url: video.productVideoDetail.url, playerType: getVideoPlayerType(video.productVideoDetail.url), stop: stop }));
    }
    return (_jsx(ImageMagnify, { smallImage: {
            src: sourceSet[ProductImageSizesPortraitEnum.detail],
            width: ProductImageWidth.DETAIL,
            height: ProductImageHeight.DETAIL,
        }, largeImage: {
            src: sourceSet[ProductImageSizesPortraitEnum.zoom],
            width: ProductImageWidth.ZOOM,
            height: ProductImageHeight.ZOOM,
        }, alt: alt, onClick: onClick, mode: isMobile ? 'pinch' : 'default', isActive: isActive, pinchZoomRef: pinchZoomRef, preloadLargeImage: preloadLargeImage, tapZoomEnabled: tapZoomEnabled }));
};
